// extracted by mini-css-extract-plugin
export var bgModal = "style-module--bg-modal--b0435";
export var btnCloseMenu = "style-module--btn-close-menu--28857";
export var header = "style-module--header--ecbff";
export var header__content = "style-module--header__content--afdc7";
export var header__description = "style-module--header__description--9207b";
export var header__img = "style-module--header__img--62d3e";
export var header__links = "style-module--header__links--d4fdc";
export var header__list = "style-module--header__list--f4d40";
export var header__listItem = "style-module--header__list-item--fc100";
export var header__logo = "style-module--header__logo--e040c";
export var header__main = "style-module--header__main--86cee";
export var header__mobMenu = "style-module--header__mob-menu--35630";
export var header__nav = "style-module--header__nav--3c37b";
export var header__navItem = "style-module--header__nav-item--bf616";
export var header__navList = "style-module--header__nav-list--cd3e2";
export var header__row = "style-module--header__row--52278";
export var header__title = "style-module--header__title--30090";
export var logo = "style-module--logo--360d6";
export var logoImg = "style-module--logo-img--44d5f";
export var mainBtn = "style-module--main-btn--56375";
export var menuOpen = "style-module--menu-open--45441";
export var phone = "style-module--phone--f20d3";
export var topLogo = "style-module--top-logo--e270c";